import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('LATEST_INCIDENT_REPORT_DATE')